<template>
  <div class="series" id="installations">
    <transition name="fade">
      <div v-if="loading">
      </div>
      <div v-else class="scroll-group" id="scroll-tracking">

        <Transition name="description">
          <div class="description-wrapper mobile">
            <div class="foldout-button" @click="unfold = !unfold" :class="{ 'unfold' : unfold }">
              <p class="description-meta" v-html="clientArray[descriptionId].meta"></p>
              <img v-if="!unfold" class="chevron" src="../assets/interface/chevron-up.svg"/>
              <img v-else class="chevron" src="../assets/interface/chevron-down.svg"/>
            </div>
            <p class="description-content" v-if="unfold" v-html="clientArray[descriptionId].content"></p>
            <p class="description-credits" v-if="unfold" v-html="clientArray[descriptionId].credits"></p>
          </div>
        </Transition>

        <div v-for="(group, groupIndex) in clientArray" :key="group.id" class="groups" :id="group.id">
          <Transition name="description">
            <div v-if="group.content || group.meta" class="description-wrapper desktop">
              <div class="foldout-button" @click="unfold = !unfold">
                <p class="description-meta" v-html="group.meta"></p>
                <img v-if="!unfold" class="chevron" src="../assets/interface/chevron-up.svg"/>
                <img v-else class="chevron" src="../assets/interface/chevron-down.svg"/>
              </div>
              <p class="description-content" v-if="unfold" v-html="group.content"></p>
              <p class="description-credits" v-if="unfold" v-html="group.credits"></p>
            </div>
          </Transition>

          <div v-for="(object, index) in group.imageslist" :key="object.id" :class="{ 'first' : index === 0 && groupIndex > 0}">
            <video v-if="object.media && object.media.match(/^.*\.(mp4)/)"
                   preload="auto"
                   controls
                   class="video-container">
              <source :src="$store.state.$fileBaseURL + object.id + '/' + object.media"/>
            </video>

            <div class="img-container"
                 @click="showLightbox($event, object)">

              <ImageLoader
                  :small="$store.state.$imageBaseURL + object.id + '/' + object.cover + '?w=28&q=50&dpr=2&token=' + $store.state.$imageToken"
                  :trueSize="$store.state.$imageHackURL + object.id + '/' + object.cover"/>

            </div>
          </div>
        </div>
      </div>
    </transition>

    <div v-if="lightboxImage" id="image-lightbox">
      <div id="lightbox-backdrop"></div>
      <p class="buttons">
        <svg id="close" @click="lightboxImage = null"
             :style="{ opacity: lightboxImage ? '1' : '0',
                       pointerEvents: lightboxImage ? 'all' : 'none'}"
             xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" width="36"
             height="36" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none"
             stroke-linecap="round" stroke-linejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </p>
      <ImageLoader id="lightbox-image"
                   :small="$store.state.$imageBaseURL + lightboxImage.id + '/' + lightboxImage.cover + '?w=8&q=50&dpr=2&token=' + $store.state.$imageToken"
                   :trueSize="$store.state.$imageBaseURL + lightboxImage.id + '/' + lightboxImage.cover + '?w=500&q=100&dpr=2&token=' + $store.state.$imageToken"/>
    </div>

  </div>
</template>

<script>
import scrollManager from '@/assets/js/scrollManager.js'
import ImageLoader from '../components/ImageLoader.vue'

export default {
  name: 'Home',
  components: {
    ImageLoader
  },
  data() {
    return {
      clientArray: [],
      renderComponent: false,
      descriptionId: 0,
      unfold: window.innerWidth >= 800,
      loading: true,
      lightboxImage: null
    }
  },
  mounted() {
    this.fetchContent();
  },
  computed: {
    mobile() {
      return this.$store.state.$mobile;
    }
  },
  watch: {
    loading(newVal) {
      if (newVal === false) {
        this.$nextTick(() => {
          let scrolltracking = document.getElementById("scroll-tracking");
          let scrollparent = document.getElementById("installations");

          if (scrolltracking) {
            scrolltracking.addEventListener("wheel", (e) => {
              console.log("wheel");
              this.changeDescription(e);
            }, {passive: true});

            scrollparent.addEventListener("scroll", (e) => {
              console.log("scroll");
              this.changeDescription(e);
            }, {passive: true});

            scrolltracking.addEventListener("touchmove", (e) => {
              console.log("touchmove");
              this.changeDescription(e);
            }, {passive: true});
          }

          if (!this.mobile) {
            const scrollableDescriptions = document.querySelectorAll('.description-wrapper.desktop');

            scrollableDescriptions.forEach(scrollable => {

              scrollable.addEventListener('wheel', function(e) {
                const { scrollTop, scrollHeight, clientHeight } = scrollable;
                const delta = e.deltaY;

                const atTop = scrollTop === 0;
                const atBottom = scrollTop + clientHeight >= scrollHeight;

                if ((atTop && delta < 0) || (atBottom && delta > 0)) {
                  return;
                }

                e.stopPropagation();
              }, { passive: false });
            });
          }
        });
      }
    }
  },
  methods: {
    showLightbox(event, object) {
      event.stopPropagation();
      this.lightboxImage = object;
    },
    changeDescription() {
      let series1 = document.getElementById("installations");
      let blocks = document.getElementsByClassName("groups");

      let i = 0;
      for (let block of blocks) {
        this.isElementVisible(block, series1, i);
        i++;
      }
    },
    isElementVisible(el, holder, i) {
      holder = holder || document.body;
      const elRect = el.getBoundingClientRect();
      const holderRect = holder.offsetWidth / 2;

      if (elRect.left <= holderRect) {
        if (this.descriptionId !== el.id) {
          this.descriptionId = i;
        }
      }
    },
    fetchContent() {
      fetch(`https://marinkagrondel.com/cms/api/entries?id=photo-series/installations&options[collection]=true&token=${process.env.VUE_APP_ENTRY_TOKEN}`)
          .then((response) => {
            if (!response.ok) {
              throw new Error('Network response was not OK');
            } else {
              response.json()
                  .then((data) => {

                    let array = Object.values(data.data);
                    let sorted = array.slice().sort((a, b) => a.sort_index - b.sort_index);

                    for (let [i, installation] of sorted.entries()) {
                      this.clientArray[i] = installation;
                      this.clientArray[i].imageslist = [];

                      fetch(`https://marinkagrondel.com/cms/api/entries?id=${installation.id}&options[collection]=true&token=${process.env.VUE_APP_ENTRY_TOKEN}`)
                          .then((response) => {
                            if (!response.ok) {
                              throw new Error('Network response was not OK')
                            } else
                              response.json()
                                  .then((imageData) => {
                                    // convert Object to Array !!!
                                    let entries = Object.values(imageData.data);
                                    let sorted = entries.slice().sort((a, b) => a.sort_index - b.sort_index);
                                    this.clientArray[i].imageslist = sorted;
                                    this.$forceUpdate();

                                    let series1 = document.getElementById("installations");

                                    this.loading = false;
                                    scrollManager(series1);
                                  })
                          })
                    }
                  });
            }
          })
    }
  }
}
</script>


<style>
#installations #image-lightbox {
  top: 0;
  left: 0;
  position: fixed;
  width: 100%;
  height: 100%;
  padding: 25px;
  z-index:1000;
}

#installations #image-lightbox img {
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

#installations #lightbox-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(227, 227, 227, 0.9);
  pointer-events: none;
  z-index: 999;
}

#installations #lightbox-image {
  z-index: 1000;
}

#installations .buttons {
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px;
}

#installations #close {
  cursor: pointer;
  width: 1.2rem;
  height: 1.2rem;
  z-index: 1001;
}

.chevron {
  width: 20px;
  height: auto;
  cursor: pointer;
  margin-left: 10px;
}

.series#installations .foldout-button img:hover {
  cursor: pointer !important;
}

.foldout-button {
  display: flex;
  align-items: start;
  justify-content: space-between;
  cursor: pointer !important;
}

.foldout-button.unfold {
  margin-top: 20px;
}

.description-wrapper.mobile {
  display: none;
}

.description-wrapper.desktop {
  display: block;
}

#installations .img-container,
#installations .video-container {
  margin-right: 10rem;
}

.groups .img-container:last-child,
.groups .video-container:last-child {
  margin-right: 0rem;
}


.groups, .img-container,
.groups, .video-container {
  height: 100%;
  position: relative;
}

.groups {
  display: flex;
}

.img-container img,
.video-container video {
  display: block;
  width: auto;
  height: 100%;
}

.description-credits {
  font-size: 0.7rem;
  margin-top: 0.7rem;
}

.description-meta h1, .description-meta h2, .description-meta h3, .description-meta h4 {
  font-size: 1rem;
  margin-bottom: 0.2rem;
}

@media only screen and (max-width: 800px) {
  #installations .description-wrapper.mobile {
    padding: var(--vertical-padding) var(--horizontal-padding) var(--vertical-padding) var(--horizontal-padding);
    padding-top: 1.5rem;
    bottom: 0;
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    left: 0;
    display: inline-block;
    background-image: linear-gradient(to right, rgb(186, 204, 180), rgb(211, 227, 208), rgb(255, 255, 255));

    -webkit-mask-image: linear-gradient(to bottom, transparent, black 10%, black 100%);
    mask-image: linear-gradient(to bottom, transparent, black 10%, black 100%);
  }

  .description-wrapper.desktop {
    display: none;
  }

  #installations .img-container {
    margin-right: 40px;
  }

}
</style>